<template>
  <div id="jumbo-tron" >
    <v-carousel hide-delimiters style="height: 100%">
      <v-carousel-item v-for="(item, i) in items" :src="'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + item.name" :key="i">
        <div class="left-bottom-gradient"></div>
      </v-carousel-item>
    </v-carousel>
    <div id="absolute-container">
      <v-layout align-end style="margin-bottom: 3.5vmax;">
        <v-flex>
          <!-- <h3 id="company-name"><img src="https://cdnblobendpoint.azureedge.net/bezzina-static/img/bezzina-logo-black.png" style="max-width:40%;"></h3> -->
          <div><span id="slogan">Pioneering luxury apartments since 1985.</span></div>
          <v-btn large color="primary" class="mx-0" @click="showVideo"><v-icon>fa-play-circle</v-icon>&nbsp;<span style="font-size: 9pt;">Play Video</span></v-btn>
          <v-btn large color="" class="mx-0" @click="$emit('showGallery')"><v-icon>fa-camera</v-icon>&nbsp;<span style="font-size: 9pt;">View Gallery</span></v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import Api from '@/api'

export default {
  data () {
    return {
      items: [{ 'name': 'default-header.jpg' }]
    }
  },
  mounted () {
    this.getImagesData()
  },
  methods: {
    showVideo () {
      this.$emit('showVideo')
    },
    getImagesData () {
      const path = '/slider-images'
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            // console.log(response.data.about)
            this.items = response.data.sliderimages
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    }
  }
}
</script>

<style scoped>
#jumbo-tron {
  position: relative;
  height: 70vh;
}
/*.parallax img{*/
.carousel img{
  /*height: 50vh;*/
  height: 100vh;
}
#slogan {
  font-size: 3vmax;
}
#company-name {
  font-size: 3.5vmax;
}
#absolute-container {
  position: absolute;
  bottom: 3vh;
  left: 3vh; 
  color: white;
}
#absolute-container button {
 font-family: 'Lato', sans-serif;
}
.carousel {
  /*margin: 0 0 0 -1.5vh;*/
  width: 100vw;
}
.left-bottom-gradient {
  z-index: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0.5;
  /*background-image: radial-gradient(circle farthest-corner at center, #15497E 0%, #3D93BC 100%);*/
  background-image: radial-gradient(at bottom left, rgba(0,0,0,1), rgba(0,0,0,0.1), rgba(255,255,255,0));
}
</style>



// WEBPACK FOOTER //
// src/components/Jumbotron.vue